"use strict";

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

define('controllers/policyHolderSelectionController',["require", "exports", "controllers/abortingRequest", "providers/ajaxSettingsProvider", "./policyHolderSelectionRoutes"], function (require, exports, abortingRequest, ajaxSettingsProvider, policyHolderSelectionRoutes) {
    "use strict";

    var PolicyHolderSelectionController = function () {
        function PolicyHolderSelectionController() {
            _classCallCheck(this, PolicyHolderSelectionController);
        }

        _createClass(PolicyHolderSelectionController, [{
            key: "getAccidentAndIncidentSummary",
            value: function getAccidentAndIncidentSummary(data) {
                return abortingRequest.send(policyHolderSelectionRoutes.getAccidentAndIncidentSummaryUrl, ajaxSettingsProvider.httpPost(data));
            }
        }, {
            key: "getAccidentAndIncidentChartData",
            value: function getAccidentAndIncidentChartData(data) {
                return abortingRequest.send(policyHolderSelectionRoutes.getAccidentAndIncidentChartDataUrl, ajaxSettingsProvider.httpPost(data));
            }
        }, {
            key: "getAccidentsAndIncidentsGridData",
            value: function getAccidentsAndIncidentsGridData(data) {
                return abortingRequest.send(policyHolderSelectionRoutes.getAccidentsAndIncidentsGridDataUrl, ajaxSettingsProvider.httpPost(data));
            }
        }, {
            key: "getAccidentsAndIncidentsDataThisWeek",
            value: function getAccidentsAndIncidentsDataThisWeek(data) {
                return abortingRequest.send(policyHolderSelectionRoutes.getAccidentsAndIncidentsDataThisWeekUrl, ajaxSettingsProvider.httpPost(data));
            }
        }, {
            key: "getAccidentsAndIncidentsDataThisMonth",
            value: function getAccidentsAndIncidentsDataThisMonth(data) {
                return abortingRequest.send(policyHolderSelectionRoutes.getAccidentsAndIncidentsDataThisMonthUrl, ajaxSettingsProvider.httpPost(data));
            }
        }, {
            key: "getAccidentsAndIncidentsDataThisYear",
            value: function getAccidentsAndIncidentsDataThisYear(data) {
                return abortingRequest.send(policyHolderSelectionRoutes.getAccidentsAndIncidentsDataThisYearUrl, ajaxSettingsProvider.httpPost(data));
            }
        }, {
            key: "getIncidentSummary",
            value: function getIncidentSummary(data) {
                return abortingRequest.send(policyHolderSelectionRoutes.getIncidentSummaryUrl, ajaxSettingsProvider.httpPost(data));
            }
        }, {
            key: "getIncidentChartData",
            value: function getIncidentChartData(data) {
                return abortingRequest.send(policyHolderSelectionRoutes.getIncidentChartDataUrl, ajaxSettingsProvider.httpPost(data));
            }
        }, {
            key: "getIncidentsGridData",
            value: function getIncidentsGridData(data) {
                return abortingRequest.send(policyHolderSelectionRoutes.getIncidentsGridDataUrl, ajaxSettingsProvider.httpPost(data));
            }
        }, {
            key: "getIncidentsDataThisWeek",
            value: function getIncidentsDataThisWeek(data) {
                return abortingRequest.send(policyHolderSelectionRoutes.getIncidentsDataThisWeekUrl, ajaxSettingsProvider.httpPost(data));
            }
        }, {
            key: "getIncidentsDataThisMonth",
            value: function getIncidentsDataThisMonth(data) {
                return abortingRequest.send(policyHolderSelectionRoutes.getIncidentsDataThisMonthUrl, ajaxSettingsProvider.httpPost(data));
            }
        }, {
            key: "getIncidentsDataThisYear",
            value: function getIncidentsDataThisYear(data) {
                return abortingRequest.send(policyHolderSelectionRoutes.getIncidentsDataThisYearUrl, ajaxSettingsProvider.httpPost(data));
            }
        }, {
            key: "saveAccidentReport",
            value: function saveAccidentReport(data) {
                return abortingRequest.send(policyHolderSelectionRoutes.saveAccidentReportUrl, ajaxSettingsProvider.httpPost(data));
            }
        }, {
            key: "sendRebuildFromDateRequest",
            value: function sendRebuildFromDateRequest(data) {
                return abortingRequest.send(policyHolderSelectionRoutes.sendRebuildFromDateRequestUrl, ajaxSettingsProvider.httpPost(data));
            }
        }, {
            key: "getLatestUserActivityDates",
            value: function getLatestUserActivityDates(data) {
                return abortingRequest.send(policyHolderSelectionRoutes.getLatestUserActivityDatesUrl, ajaxSettingsProvider.httpPost(data));
            }
        }, {
            key: "fetchDeviceReplacementRequests",
            value: function fetchDeviceReplacementRequests(data) {
                return abortingRequest.send(policyHolderSelectionRoutes.fetchDeviceReplacementRequestsUrl, ajaxSettingsProvider.httpPost(data));
            }
        }, {
            key: "requestDeviceReplacement",
            value: function requestDeviceReplacement(data) {
                return abortingRequest.send(policyHolderSelectionRoutes.requestDeviceReplacementUrl, ajaxSettingsProvider.httpPost(data));
            }
        }, {
            key: "getLastKnownPositionForImei",
            value: function getLastKnownPositionForImei(data) {
                return abortingRequest.send(policyHolderSelectionRoutes.getLastKnownPositionForImeiUrl, ajaxSettingsProvider.httpPost(data));
            }
        }, {
            key: "getPoliciesForUser",
            value: function getPoliciesForUser(data) {
                return abortingRequest.send(policyHolderSelectionRoutes.getPoliciesForUserUrl, ajaxSettingsProvider.httpPost(data));
            }
        }, {
            key: "getMidweightPoliciesByClientId",
            value: function getMidweightPoliciesByClientId(data) {
                return abortingRequest.send(policyHolderSelectionRoutes.getMidweightPoliciesByClientIdUrl, ajaxSettingsProvider.httpPost(data));
            }
        }, {
            key: "getMidweightPolicyByBrokerPolicyId",
            value: function getMidweightPolicyByBrokerPolicyId(data) {
                return abortingRequest.send(policyHolderSelectionRoutes.getMidweightPolicyByBrokerPolicyIdUrl, ajaxSettingsProvider.httpPost(data));
            }
        }, {
            key: "getMidweightPolicyByBillingRef",
            value: function getMidweightPolicyByBillingRef(data) {
                return abortingRequest.send(policyHolderSelectionRoutes.getMidweightPolicyByBillingRefUrl, ajaxSettingsProvider.httpPost(data));
            }
        }, {
            key: "getMidweightPolicyByPolicyId",
            value: function getMidweightPolicyByPolicyId(data) {
                return abortingRequest.send(policyHolderSelectionRoutes.getMidweightPolicyByPolicyIdUrl, ajaxSettingsProvider.httpPost(data));
            }
        }, {
            key: "getMidweightPolicyByVehicleReg",
            value: function getMidweightPolicyByVehicleReg(data) {
                return abortingRequest.send(policyHolderSelectionRoutes.getMidweightPoliciesByVehicleRegUrl, ajaxSettingsProvider.httpPost(data));
            }
        }, {
            key: "getMidweightPoliciesByImei",
            value: function getMidweightPoliciesByImei(data) {
                return abortingRequest.send(policyHolderSelectionRoutes.getMidweightPoliciesByImeiUrl, ajaxSettingsProvider.httpPost(data));
            }
        }, {
            key: "getMidweightPoliciesByUnitSerialNumber",
            value: function getMidweightPoliciesByUnitSerialNumber(data) {
                return abortingRequest.send(policyHolderSelectionRoutes.getMidweightPoliciesByUnitSerialNumberUrl, ajaxSettingsProvider.httpPost(data));
            }
        }, {
            key: "getAverageLocation",
            value: function getAverageLocation(data) {
                return abortingRequest.send(policyHolderSelectionRoutes.getAverageLocationRequestUrl, ajaxSettingsProvider.httpPost(data));
            }
            //wrong response object!!

        }, {
            key: "getCreatedDatePosition",
            value: function getCreatedDatePosition(data) {
                return abortingRequest.send('/api/PolicyHolderInfo/GetCreatedDatePosition', ajaxSettingsProvider.httpPost(data));
            }
            //wrong response object!!

        }, {
            key: "updateRiskLatLng",
            value: function updateRiskLatLng(data) {
                return abortingRequest.send(policyHolderSelectionRoutes.updateRiskLatLngUrl, ajaxSettingsProvider.httpPost(data));
            }
        }, {
            key: "getOverNightLocation",
            value: function getOverNightLocation(data) {
                return abortingRequest.send('/api/PolicyHolderInfo/GetOverNightLocation', ajaxSettingsProvider.httpPost(data));
            }
        }, {
            key: "getCommutingData",
            value: function getCommutingData(data) {
                return abortingRequest.send('/api/PolicyHolderInfo/GetCommutingData', ajaxSettingsProvider.httpPost(data));
            }
        }, {
            key: "getBusinessData",
            value: function getBusinessData(data) {
                return abortingRequest.send('/api/PolicyHolderInfo/GetBusinessData', ajaxSettingsProvider.httpPost(data));
            }
        }, {
            key: "getFullPolicyDetails",
            value: function getFullPolicyDetails(data) {
                return abortingRequest.send(policyHolderSelectionRoutes.getFullPolicyDetailsUrl, ajaxSettingsProvider.httpPost(data));
            }
        }, {
            key: "getDeviceAllocations",
            value: function getDeviceAllocations(data) {
                return abortingRequest.send('/api/PolicyHolderInfo/GetDeviceAllocations', ajaxSettingsProvider.httpPost(data));
            }
        }, {
            key: "getAllPoliciesForPolicyHolder",
            value: function getAllPoliciesForPolicyHolder(data) {
                return abortingRequest.send(policyHolderSelectionRoutes.getAllPoliciesForPolicyHolderUrl, ajaxSettingsProvider.httpPost(data));
            }
        }, {
            key: "getAllVehiclesForPolicy",
            value: function getAllVehiclesForPolicy(data) {
                return abortingRequest.send(policyHolderSelectionRoutes.getAllVehiclesForPolicyUrl, ajaxSettingsProvider.httpPost(data));
            }
        }, {
            key: "getDvlaInfoForVehicle",
            value: function getDvlaInfoForVehicle(data) {
                return abortingRequest.send('/api/PolicyHolderInfo/GetDvlaInfoForVehicle', ajaxSettingsProvider.httpPost(data));
            }
        }, {
            key: "getAllAddressesForPolicyHolder",
            value: function getAllAddressesForPolicyHolder(data) {
                return abortingRequest.send(policyHolderSelectionRoutes.getAllAddressesForPolicyHolderUrl, ajaxSettingsProvider.httpPost(data));
            }
        }, {
            key: "getPolicyHistory",
            value: function getPolicyHistory(data) {
                return abortingRequest.send(policyHolderSelectionRoutes.getPolicyHistoryUrl, ajaxSettingsProvider.httpPost(data));
            }
        }, {
            key: "getInsuranceClaims",
            value: function getInsuranceClaims(environment, brokerPolicyId) {
                return abortingRequest.send('/api/PolicyHolderInfo/InsuranceClaims/' + environment + '/' + brokerPolicyId, ajaxSettingsProvider.httpGet());
            }
        }, {
            key: "getAddressHistory",
            value: function getAddressHistory(data) {
                return abortingRequest.send(policyHolderSelectionRoutes.getAddressHistoryUrl, ajaxSettingsProvider.httpPost(data));
            }
        }, {
            key: "getPolicyHolderHistory",
            value: function getPolicyHolderHistory(data) {
                return abortingRequest.send(policyHolderSelectionRoutes.getPolicyHolderHistoryUrl, ajaxSettingsProvider.httpPost(data));
            }
        }, {
            key: "getDeviceDataForImei",
            value: function getDeviceDataForImei(data) {
                return abortingRequest.send(policyHolderSelectionRoutes.getDeviceDataForImeiUrl, ajaxSettingsProvider.httpPost(data));
            }
        }, {
            key: "getLatestSummary",
            value: function getLatestSummary(data) {
                return abortingRequest.send(policyHolderSelectionRoutes.getLatestSummaryUrl, ajaxSettingsProvider.httpPost(data));
            }
        }, {
            key: "rebuildAllJourneysForImei",
            value: function rebuildAllJourneysForImei(data) {
                return abortingRequest.send(policyHolderSelectionRoutes.rebuildAllJourneysForImeiUrl, ajaxSettingsProvider.httpPost(data));
            }
        }, {
            key: "updatePolicyVehicle",
            value: function updatePolicyVehicle(data) {
                return abortingRequest.send(policyHolderSelectionRoutes.updatePolicyVehicleUrl, ajaxSettingsProvider.httpPost(data));
            }
        }, {
            key: "updateAddress",
            value: function updateAddress(data) {
                return abortingRequest.send('/api/PolicyHolderInfo/UpdateAddress', ajaxSettingsProvider.httpPost(data));
            }
        }, {
            key: "suggestShippingAddress",
            value: function suggestShippingAddress(data) {
                return abortingRequest.send('/api/PolicyHolderInfo/SuggestShippingAddress', ajaxSettingsProvider.httpPost(data));
            }
        }, {
            key: "addShippingAddress",
            value: function addShippingAddress(data) {
                return abortingRequest.send('/api/PolicyHolderInfo/AddShippingAddress', ajaxSettingsProvider.httpPost(data));
            }
        }, {
            key: "deletePolicyVehicle",
            value: function deletePolicyVehicle(data) {
                return abortingRequest.send(policyHolderSelectionRoutes.deletePolicyVehicleUrl, ajaxSettingsProvider.httpPost(data));
            }
        }, {
            key: "addDeviceAllocation",
            value: function addDeviceAllocation(data) {
                return abortingRequest.send('/api/PolicyHolderInfo/AddDeviceAllocation', ajaxSettingsProvider.httpPost(data));
            }
        }, {
            key: "updateDeviceAllocation",
            value: function updateDeviceAllocation(data) {
                return abortingRequest.send(policyHolderSelectionRoutes.updateDeviceAllocationUrl, ajaxSettingsProvider.httpPost(data));
            }
        }, {
            key: "deleteDeviceAllocation",
            value: function deleteDeviceAllocation(data) {
                return abortingRequest.send(policyHolderSelectionRoutes.deleteDeviceAllocationUrl, ajaxSettingsProvider.httpPost(data));
            }
        }]);

        return PolicyHolderSelectionController;
    }();

    return new PolicyHolderSelectionController();
});
//# sourceMappingURL=policyHolderSelectionController.js.map;
